<template>
    <div>
      <Header :title="title" />
      <div class="footer_podat" v-if="podkateg">
        <div class="main">
          <div align="center">
            <button class="btns" @click="dale()">Далее</button>
          </div>
        </div>
      </div>
  
      <div class="content_podat">
        <div v-if="loading" align="center">
          <div class="spinpodat"><Spinner /></div>
        </div>
        <div v-else>
          <div v-for="pk in arr" :key="pk.id" class="block_radio">
            <input
              class="custom-radio"
              name="color"
              v-model="podkateg"
              type="radio"
              :id="pk.idpodkateg"
              :value="pk.idpodkateg"
              @change="select"
            />
            <label :for="pk.idpodkateg">{{ pk.textpodkateg }} </label>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import Header from "../components/headerpodat";
  import axios from "axios";
  import Spinner from "../blocks/spinner";
  export default {
    components: {
      Header,
      Spinner,
    },
    data() {
      return {
        title: "Выберите раздел",
        loading: true,
        podkateg: "",
        txtpodkateg: "",
        arr: [],
      };
    },
    methods: {
      select() {
        const values = Object.values(this.arr);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i].idpodkateg === this.podkateg) this.txtpodkateg = values[i].textpodkateg;
        }
        
        localStorage.setItem("obmen_razdel",this.podkateg);
        localStorage.setItem("obmen_razdel_text",this.txtpodkateg);
        
        this.dale();
      },
      dale() {
          this.$router.push({name:"markaObmen"});
      },
    },
    
   
    mounted() {
      axios({
        method: "post",
        url: "https://avtobaza.tj/api/getpodkateg",
        data: {
          id: localStorage.getItem("obmen_kateg"),
        },
      }).then((res) => {
        if (res.data.status) {
          this.loading = false;
          this.arr = res.data.podkategs;
        } else {
          this.loading = false;
          alert("ERROR");
        }
      });
    },
  };
  </script>
  <style scoped>
  .block_radio {
    margin-bottom: 1.4em;
  }
  .divgorod {
    width: 100%;
    color: #777777;
  }
  .contentgorod {
    font-size: 20px;
    border-bottom: 1px solid #000000;
    padding: 5px 5px 5px 0px;
  }
  label {
    font-size: 18px;
    width: 100%;
  }
  .content_podat {
    padding: 90px 5px 65px 10px;
  }
  </style>